/*
 *  -----------------------------------------------------------------------
 *    <copyright file="select-with-categories-lov.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import cn from 'clsx';
import React from 'react';
import Constants from '../../../../utils/constants';
import {
    SelectWithCategoriesLovItem,
    SelectWithCategoriesLovProps,
    SelectWithSearchDataArrayInterface,
} from './select-with-categories.interface';
import SelectWithCategories from './index';
import { SortDescriptor } from '@progress/kendo-data-query';

const SelectWithCategoriesLov = ({
    label,
    onChange,
    namedItems,
    labelField,
    fieldSelect,
    customId,
    customClassName,
    disabled,
    customLabelId = null,
    error,
    opened,
    currentItem,
    initialState,
    defaultText,
    grouped,
}: SelectWithCategoriesLovProps) => {
    const getDataArray = () => {
        const result = namedItems.map(
            (item: SelectWithCategoriesLovItem) =>
                ({
                    id: item.id,
                    text: item.name,
                    active: item.active,
                    default: false,
                }) as SelectWithSearchDataArrayInterface,
        );

        result.unshift({
            id: Constants.ObjectId.Empty,
            text: defaultText,
            active: true,
            default: true,
        });

        return result;
    };

    const inactive = currentItem?.active === false;
    const sortDescriptors = (): SortDescriptor[] => {
        const descriptors: SortDescriptor[] = [];
        // To fix an issue where the default item is not placed at the top when not grouped
        // The SelectWithCategories applies the order by on default only if filterable is true
        // Now that LOVs are always sorted alphanumerically, we need to ensure that the default
        // item is at the top of the list, even when not grouped/filterable
        if (!grouped) descriptors.push({ field: 'default', dir: 'desc' });

        descriptors.push({ field: 'text', dir: 'asc' });

        return descriptors;
    };

    return (
        <SelectWithCategories
            label={label}
            onChange={onChange}
            dataArray={getDataArray()}
            sortDescriptors={sortDescriptors()}
            labelField={labelField}
            fieldSelect={fieldSelect}
            customId={customId}
            customClassName={cn('form-action-type', { inactive }, customClassName)}
            showWarning={inactive}
            currentState={currentItem?.id}
            filterable={!!grouped}
            disabled={disabled}
            searchable
            customLabelId={customLabelId}
            showLabels={!!grouped}
            error={error}
            opened={opened}
            activeOnly={!grouped}
            initialState={initialState}
        />
    );
};

export default SelectWithCategoriesLov;
